/* eslint-disable */
const localization = {
    // This is the array of lexemes found in the app
    lexemes: [
      "Download på App Store",
      "Mød folk personligt",
      "Skab kontakt med din nye gruppe i Hives",
      "Find folk, der er ligesom dig",
      "Der findes en Hive for dig, uanset din passion!",
      "Et trygt sted at være dig",
      "Vælg fra enten skjulte eller synlige Hives.",
      "Kom i gang",
      "Der findes en Hive for dig, uanset din passion",
      "Lær en ny gruppe af folk at kende i Hives på Bumble BFF",
      "Du er inviteret til Hives",
      "Mød nye grupper af lokale folk på Bumble BFFs nye funktion: Hives. Lav din BFF-profil på Bumble-appen i dag.",
      "Hent den på Google Play",
      "Administrer cookies",
      "Gender Pay Gap",
      "Modern Slavery Statement",
      "Terms and Conditions",
      "About",
      "Life"
],

    // These are the common words found in the lexemes of the app
    common: {
      "day": {
            "plural": [
                  "dage",
                  "dages"
            ],
            "singular": [
                  "dag",
                  "dags"
            ]
      },
      "hour": {
            "plural": [
                  "timer",
                  "timers"
            ],
            "singular": [
                  "time",
                  "times"
            ]
      },
      "minute": {
            "plural": [
                  "minutter",
                  "minutters"
            ],
            "singular": [
                  "minut",
                  "minuts"
            ]
      },
      "month": {
            "plural": [
                  "måneder",
                  "måneders"
            ],
            "singular": [
                  "måned",
                  "måneds"
            ]
      },
      "second": {
            "plural": [
                  "sekunder",
                  "sekunders"
            ],
            "singular": [
                  "sekund",
                  "sekunds"
            ]
      },
      "year": {
            "plural": [
                  "år",
                  "årenes"
            ],
            "singular": [
                  "år",
                  "årets"
            ]
      }
}
};

// In dev mode we extend lexemes to include the indexMap as well, in production it remains as an array
if (__DEV__) {
    // This is a map of lexeme ids to their index in the array, it's only needed during development
    const indexMap = require('./index-map').default;

    localization.indexMap = indexMap;

    Object.entries(localization.indexMap).forEach(([indexKey, indexValue]) => {
        localization.lexemes[indexKey] = localization.lexemes[indexValue];
    });
}

export default localization;
